// extracted by mini-css-extract-plugin
export default {"RootCardTraffic":"DevicesScreen_RootCardTraffic__ayIUb"};